export default "__VITE_ASSET__02c368bd__"